// ReraUploadModal.jsx
import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
} from "@mui/material";
import * as pdfjsLib from "pdfjs-dist";

pdfjsLib.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js";

const extractTextFromPdfFile = async (file) => {
  const data = await file.arrayBuffer();
  const loadingTask = pdfjsLib.getDocument({ data });
  const pdf = await loadingTask.promise;
  let fullText = "";

  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i);
    const content = await page.getTextContent();
    const strings = content.items.map((item) => item.str || "");
    fullText += strings.join(" ") + " ";
  }

  return fullText.replace(/\s+/g, " ").trim();
};

const ReraUploadModal = ({ open, onClose, onExtractData }) => {
  const fileRef = useRef();
  const [error, setError] = useState("");
  const [uploaded, setUploaded] = useState(false);

  
useEffect(() => {
  if (open) {
    // Reset state every time modal opens
    setUploaded(false);
    setError("");
    if (fileRef.current) fileRef.current.value = null;
  }
}, [open]);

  const handleFile = async (e) => {
    setError("");
    const file = e.target.files?.[0];

    if (!file || file.type !== "application/pdf") {
      setError("Please upload a valid PDF file.");
      setUploaded(false);
      return;
    }

    try {
      const text = await extractTextFromPdfFile(file);
      if (!text || text.length < 20) {
        setError("The PDF doesn't contain readable text. It might be scanned.");
        setUploaded(false);
        return;
      }

      setUploaded(true); // ✅ mark as uploaded
      onExtractData(text);
        onClose();
    } catch (err) {
      console.error("❌ Failed to read uploaded PDF:", err);
      setError(`Failed to read the PDF: ${err.message}`);
      setUploaded(false);
    }
        // onClose();
  };

  const handleClose = () => {
    if (!uploaded) {
      setError("⚠️ Uploading the RERA certificate is mandatory.");
      return; // ❌ prevent closing until uploaded
    }
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle sx={{ fontSize: "1.7rem", fontWeight: "bold" }}>
        Upload RERA Certificate
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2, fontSize: "1.4rem" }}>
          Please upload your RERA Certificate PDF for manual verification.
        </Typography>
        {error && (
          <Typography
            color="error"
            variant="body1"
            sx={{ mb: 1, fontSize: "1rem", fontWeight: 500 }}
          >
            {error}
          </Typography>
        )}
        <Button
          variant="contained"
          sx={{ fontSize: "1.3rem", padding: "10px 20px", mt: 2 }}
          onClick={() => fileRef.current?.click()}
        >
          Upload PDF
        </Button>
        <input
          ref={fileRef}
          type="file"
          accept="application/pdf"
          hidden
          onChange={handleFile}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ReraUploadModal;
